import { render, staticRenderFns } from "./priceListForm.vue?vue&type=template&id=6842853d&"
import script from "./priceListForm.vue?vue&type=script&lang=js&"
export * from "./priceListForm.vue?vue&type=script&lang=js&"
import style0 from "./priceListForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports